import React, { Component } from 'react'

/**
 * @augments {Component<{show: boolean, width:string, marginRight: string, marginLeft:string, marginBottom: string, marginTop: string}, State>}
 */
class Modalv4 extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (!this.props.show)
            return null;
        return (
            <div>
                {/*<!-- Modal -->*/}
                <div className={"modal d-block"} >
                    <div className={"modal-dialog " + (this.props.className ? " " + this.props.className : "")}>
                        <div className="modal-content">
                            {this.props.children}
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop show"></div>
            </div>
        )
    }
}

/**
 * @augments {Component<{onClose: function}, State>}
 */
class Header extends Component {
    render() {
        {/** Titolo del popup */ }
        return <div className={"modal-header " + (this.props.className ? this.props.className : "")} >
            {this.props.children}
            <button type="button" className="close" id={this.props.id} onClick={this.props.onClose}>
                <span>&times;</span>
            </button>
        </div>
    }
}

/**
 * @augments {Component<{maxHeight: string}, State>}
 */
class Body extends Component {
    render() {
        {/** Da inserire qua il contenuto del popup */ }
        return <div className={"modal-body" + (this.props.className ? " " + this.props.className : "")}>
            {this.props.children}
        </div>
    }
}

/**
 * @augments {Component<{}, State>}
 */
class Footer extends Component {
    render() {
        {/**Da inserire qua il contenuto per il footer del popup */ }
        return <div className={"modal-footer d-flex justify-content-between" + (this.props.className ? " " + this.props.className : "")}>
            {this.props.children}
        </div>
    }
}

Modalv4.Header = Header;
Modalv4.Body = Body;
Modalv4.Footer = Footer;

export default Modalv4;